<template>
  <div class="snag-card">
    <div class="snag-card-body">
      <!-- Left: Product Image -->
      <div class="product-image">
        <img :src="item.image" :alt="item.title">
      </div>

      <!-- Right: Content -->
      <div class="snag-details">
        <div class="details-top">
          <div class="info-column">
            <div class="status-tag" v-if="item.status">{{ item.status }}</div>
            <h3 class="product-title">{{ item.title }}</h3>
            <div class="coupon-info" v-if="item.isCompleted && item.couponcode">
              <span class="coupon-label">Code : </span>
              <span class="coupon-value">{{ item.couponcode }}</span>
            </div>
            <div class="remark-info" v-if="item.remark">
              <span class="remark-label">Remark : </span>
              <span class="remark-value">{{ item.remark }}</span>
            </div>
            <div class="cashback-info" v-else>
              <svg class="cashback-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M6 12h.01M18 12h.01"></path>
              </svg>
              <span class="cashback-label">cash back</span>
              <span class="cashback-via">via Wallet</span>
            </div>
          </div>
          <div class="action-column">
            <button class="complete-action-btn" @click="viewOrderDetail">
              View Order
            </button>
          </div>
        </div>

        <!-- Stepper -->
        <div class="stepper-container">
          <div class="stepper">
            <div v-for="(step, index) in steps" :key="index" class="step-item" :class="{ 
              'active': index + 1 <= item.currentStep,
              'completed': index + 1 < item.currentStep || (item.isCompleted && index + 1 === steps.length)
            }">
              <div class="step-circle">
                <template v-if="index + 1 < item.currentStep || (item.isCompleted && index + 1 === steps.length)">
                  <svg viewBox="0 0 24 24" width="14" height="14" class="check-icon">
                    <polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></polyline>
                  </svg>
                </template>
                <template v-else>
                  {{ index + 1 }}
                </template>
              </div>
              <div class="step-label">{{ step }}</div>
              <div v-if="index < steps.length - 1" class="step-line" :class="{ 'active': index + 1 < item.currentStep || (item.isCompleted && index + 1 < steps.length) }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SnagCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      steps: ['Confirm order','Pending approval', 'Completed']
    }
  },
  methods: {
    viewOrderDetail() {
      this.$router.push(`/order-detail/${this.item.id}`)
    }
  }
}
</script>

<style scoped>
.snag-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.snag-card-body {
  display: flex;
  gap: 24px;
}

.product-image {
  width: 160px;
  height: 160px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.snag-details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.details-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.status-tag {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.product-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.coupon-info {
  margin-bottom: 8px;
  font-size: 16px;
  color: #999;
}

.coupon-value {
  color: #666;
  font-weight: 500;
}

.remark-info {
  margin-bottom: 8px;
  font-size: 14px;
  color: #999;
}

.remark-value {
  color: #666;
}

.cashback-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.cashback-icon {
  color: #333;
}

.cashback-label {
  color: #333;
  font-weight: 500;
}

.cashback-via {
  color: #999;
}
.action-column {
  flex-shrink: 0;
}
.complete-action-btn {
  background: black;
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;
}

.complete-action-btn:hover {
  opacity: 0.8;
}

/* Stepper Styles */
.stepper-container {
  margin-top: auto;
  padding-top: 20px;
}

.stepper {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 300px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  z-index: 1;
}

.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #999;
  margin-bottom: 8px;
  transition: all 0.3s;
}

.step-label {
  font-size: 11px;
  color: #999;
  text-align: center;
  white-space: nowrap;
}

.step-line {
  position: absolute;
  top: 14px;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  z-index: -1;
}

.step-item.active .step-circle {
  border-color: #00d4aa;
  color: #00d4aa;
}

.step-item.completed .step-circle {
  background: #00d4aa;
  border-color: #00d4aa;
  color: white;
}

.step-item.completed .step-label {
  color: #00d4aa;
}

.step-item.active .step-label {
  color: #00d4aa;
}

.step-line.active {
  background: #00d4aa;
}

.check-icon {
  color: white;
}

@media (max-width: 768px) {
  .snag-card-body {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .details-top {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .stepper {
    max-width: 100%;
  }
  
  .step-label {
    font-size: 10px;
    white-space: normal;
  }
}
</style>
